
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M17.296 22.34c0-.53.43-.961.961-.961h9.61c.53 0 .96.43.96.96v8.649c0 .53-.43.96-.96.96h-9.61a.96.96 0 0 1-.96-.96z"}}),_c('path',{attrs:{"stroke":"#D0EFEC","stroke-linecap":"round","stroke-width":"1.001","d":"M19.699 25.223h6.726m-8.168 6.726h9.61c.53 0 .96-.43.96-.961V22.34a.96.96 0 0 0-.96-.961h-9.61a.96.96 0 0 0-.96.96v8.649c0 .53.43.96.96.96Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M16.939 5.5h14.693a2.44 2.44 0 0 1 2.438 2.438v32.325a2.44 2.44 0 0 1-2.438 2.44H16.939a2.44 2.44 0 0 1-2.439-2.44V7.938c0-1.262.96-2.3 2.19-2.425zM21 10.377h5.877"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-width":"1.001","d":"M20.747 23.781h6.726m-.48-5.765v2.882m-5.765-2.882v2.882m-1.922 9.61h9.609c.53 0 .96-.43.96-.961v-8.649c0-.53-.43-.96-.96-.96h-9.61c-.53 0-.96.43-.96.96v8.649c0 .53.43.96.96.96Z"}})])
          )
        }
      }
    